(function() {

    angular
        .module('ngmvac')
        .directive('typeahead', Typeahead, ['$window']);


    ;
    (function($) {
        $.fn.extend({
            donetyping: function(callback, timeout) {
                timeout = timeout || 1e3; // 1 second default timeout
                var timeoutReference,
                    doneTyping = function(el) {
                        if (!timeoutReference) return;
                        timeoutReference = null;
                        callback.call(el);
                    };
                return this.each(function(i, el) {
                    var $el = $(el);
                    // Chrome Fix (Use keyup over keypress to detect backspace)
                    // thank you @palerdot
                    $el.is(':input') && $el.on('keyup keypress paste', function(e) {
                        // This catches the backspace button in chrome, but also prevents
                        // the event from triggering too preemptively. Without this line,
                        // using tab/shift+tab will make the focused element fire the callback.
                        if (e.type == 'keyup' && e.keyCode != 8) return;

                        // Check if timeout has been set. If it has, "reset" the clock and
                        // start over again.
                        if (timeoutReference) clearTimeout(timeoutReference);
                        timeoutReference = setTimeout(function() {
                            // if we made it here, our timeout has elapsed. Fire the
                            // callback
                            doneTyping(el);
                        }, timeout);
                    }).on('blur', function() {
                        // If we can, fire the event since we're leaving the field
                        doneTyping(el);
                    });
                });
            }
        });
    })(jQuery);

    function Typeahead($window) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                $(element).typeahead({
                    minLength: 3,
                    maxItem: 350,
                    // order: "asc",
                    hint: true,
                    accent: true,
                    searchOnFocus: false,
                    dynamic: true,
                    backdropOnFocus: false,
                    // backdrop: {
                    //     "background-color": "#3879d9",
                    //     "opacity": "0.4",
                    //     "filter": "alpha(opacity=10)"
                    // },
                    display: ['name', 'country_name', 'city_name'],
                    source: {
                        destinations: {
                            ajax: {
                                url: 'https://uky88frl3j.execute-api.us-west-2.amazonaws.com/Prod/mvac-search/{{query}}',
                                callback: {
                                    done: function(data) {
                                        var results = data.hits.hit.map(function(hit) {
                                            return {
                                                city_name: hit.fields.city_name,
                                                code: hit.fields.code,
                                                country_name: hit.fields.country_name,
                                                name: hit.fields.name,
                                                type: hit.fields.type,
                                                zone_code: hit.fields.zone_code,
                                                hotel_code: hit.fields.hotel_code,
                                                country_code: hit.fields.country_code,
                                                city_code: hit.fields.city_code
                                            }
                                        });
                                        return results;
                                    }
                                }
                            }
                        }
                    },
                    template: function(query, item) {
                        var resultItem = "";
                        switch (item.type) {
                            case 'Hotel':
                                resultItem = "<i class='fas fa-building'></i> - <small> {{name}} - {{country_name}}</small>";
                                break;

                            case 'Zone':
                                resultItem = "<i class='fas fa-building'></i> - <small> {{name}} - {{country_name}}</small>";
                                break;
                            
                            default:
                                resultItem = "<i class='fas fa-map-marker-alt'></i> - <small> {{name}} - {{country_name}}</small>";
                                break;
                        }
                        return resultItem;
                    },
                    debug: true,
                    callback: {
                        onClick: function (node, item, event) {
                            localStorage.setItem('selectedCity', JSON.stringify(event));
                            $(element).trigger('typeahead:callback.onClick')
                        },
                    }
                });
            }
        }
    }

})();